export default class {
	idItemPedido
	quantidadeSolicitada

	constructor(idItemPedido, quantidadeSolicitada) {
		this.idItemPedido = idItemPedido
		this.quantidadeSolicitada = quantidadeSolicitada
	}
}
